import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const ADMIN_TOKEN_KEY = "cc_admin_token";
const TV_TOKEN_KEY = "cc_tv_token";

export const tokenStore = {
  getAdmin: () => localStorage.getItem(ADMIN_TOKEN_KEY),
  setAdmin: (t) => localStorage.setItem(ADMIN_TOKEN_KEY, t),
  clearAdmin: () => localStorage.removeItem(ADMIN_TOKEN_KEY),
  getTV: () => localStorage.getItem(TV_TOKEN_KEY),
  setTV: (t) => localStorage.setItem(TV_TOKEN_KEY, t),
  clearTV: () => localStorage.removeItem(TV_TOKEN_KEY),
};

export const apiAdmin = axios.create({ baseURL: API });
apiAdmin.interceptors.request.use((config) => {
  const t = tokenStore.getAdmin();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const apiTV = axios.create({ baseURL: API });
apiTV.interceptors.request.use((config) => {
  const t = tokenStore.getTV();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(", ");
  return err?.message || "Something went wrong";
}

export function buildFileUrl(mediaId, tokenType = "admin") {
  const token = tokenType === "tv" ? tokenStore.getTV() : tokenStore.getAdmin();
  return `${API}/files/${mediaId}?auth=${encodeURIComponent(token || "")}`;
}
